export enum NeerTreatmentTagIds {
  approved = 42,
}

export enum NeerTreatmentTagNames {
  approved = 'Approved',
}
